module.exports = __webpack_public_path__ + "static/1_RevitLogo-82aa9b9cdd576940b515fd1c969eaa29.png";